import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import { Heading, Paragraph } from '@nrk/dh-feature-components'
import PureComponent from '../../../lib/preact-pure-component'
import classNames from 'classnames'
import { isIOSSafari } from '../../../lib/isIOSSafari'
import { createImageUrl } from '../../../lib/serum-imagecrop'
import { Card } from './card'
import { Link } from './link'
export interface LinkData {
  image: string
  text: string
  href: string
}
export interface image {
  imgUrl: string
}

interface Props {
  publishedAt: string
  links: LinkData[]
  active: boolean
  preload: boolean
  addIntersectionElement: () => void
}

interface State {
  intersectionElements: any[]
  active?: number
}

export class LinkOut extends PureComponent<Props, State> {
  timing: HTMLDivElement[] = []
  intersectionObserver?: IntersectionObserver

  constructor() {
    super()
    this.state = {
      intersectionElements: [],
      active: undefined
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.preload && this.props.preload) {
      this.mount()
    }
    if (prevProps.active && !this.props.active) {
      this.setState({ active: undefined })
    }
  }

  mount = () => {
    let rootMargin = isIOSSafari() ? '0px 0px 75px 0px' : '0px'
    var options = { root: null, rootMargin, threshold: [0] }
    this.intersectionObserver = new IntersectionObserver(this.handleIntersect, options)
    this.addIntersectionElements()
    this.state.intersectionElements.forEach(el => {
      if (this.intersectionObserver) {
        this.intersectionObserver.observe(el)
      }
    })
  }

  componentWillUnmount() {
    this.intersectionObserver ? this.intersectionObserver.disconnect() : null
  }

  addIntersectionElements = () => {
    this.timing.forEach(el => {
      this.addIntersectionElement(el)
    })
  }

  addIntersectionElement = (el: HTMLElement) => {
    this.setState({ intersectionElements: [el, ...this.state.intersectionElements] })
  }

  handleIntersect = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(entry => {
      const id = entry.target.id
      const index = parseInt(id.substring(id.lastIndexOf('-') + 1))
      if (entry.isIntersecting && (!!!this.state.active || index > this.state.active)) {
        this.setState({ active: index })
      } else if (index === this.state.active && index !== 0) {
        this.setState({ active: index - 1 })
      } else if (index === 0 && this.state.active === 0) {
        this.setState({ active: undefined })
      }
    })
  }

  getTimingElements = () => {
    return [0].map((x, idx) => (
      <div key={idx} className={style.timing} id={`card-timing-${idx}`} ref={el => (this.timing[idx] = el)} />
    ))
  }

  render() {
    const { links, preload } = this.props
    const timingElements = this.getTimingElements()
    const mappedLinks = links.map(linkData => {
      const imgUrl = createImageUrl({ id: linkData.image, width: 400, quality: 0.6 })
      return <Link image={imgUrl} linkData={linkData} key={linkData.text} />
    })

    if (preload) {
      return (
        <div className={style.wrapper}>
          <div className={style.linkWrapper}>
            <Card active={this.state.active === 0}>
              <h3 className={style.header}>{this.props.text}</h3>
              <div className={style.links}>{mappedLinks}</div>
            </Card>
          </div>
          {timingElements}
        </div>
      )
    }
    return null
  }
}
